import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'

import AsyncSelect from "react-select/async";
import axios from "axios";

import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { getTrans as t } from "../../Localization/translations";
import DeleteItemmasterService from "../../services/itemmaster/itemmasterDeleteService";

function ItemMaster({customerPermission}) {
  const ItemMastertableRef = React.createRef();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const [selectedValue, setSelectedValue] = useState("");
  const [inputvalue, setValue] = useState("");
  const [selectedValue2, setSelectedValue2] = useState("");
  const [inputvalue2, setValue2] = useState("");
  const [selectedValue3, setSelectedValue3] = useState("");
  const [inputvalue3, setValue3] = useState("");
  const [selectedValue4, setSelectedValue4] = useState("");
  const [inputvalue4, setValue4] = useState("");
  const [selectedValue5, setSelectedValue5] = useState("");
  const [inputvalue5, setValue5] = useState("");
  const [selectedValue6, setSelectedValue6] = useState("");
  const [inputvalue6, setValue6] = useState("");
  const [permissionss,setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
const [asset_type, setAsset_type] = useState("")
  let navigate = useNavigate();

  const handelSearch = () => {
    ItemMastertableRef.current.onQueryChange();
  };

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const handelInputChange2 = (value1) => {
    setValue2(value1);
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };
  const handelInputChange6 = (value1) => {
    setValue6(value1);
  };

  const handelChange6 = (value1) => {
    setSelectedValue6(value1);
  };

  const loadOptions6 = async (inputValue6) => {
    if (inputValue6 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?manufacturer=${inputValue6}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };
  const handelInputChange4 = (value1) => {
    setValue4(value1);
  };

  const handelChange4 = (value1) => {
    setSelectedValue4(value1);
  };

  const loadOptions4 = async (inputValue4) => {
    if (inputValue4 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?make=${inputValue4}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };
  
  const handelInputChange5 = (value1) => {
    setValue5(value1);
  };

  const handelChange5 = (value1) => {
    setSelectedValue5(value1);
  };

  const loadOptions5 = async (inputValue5) => {
    if (inputValue5 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?status=${inputValue5}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelInputChange3 = (value1) => {
    setValue3(value1);
  };

  const handelChange3 = (value1) => {
    setSelectedValue3(value1);
  };

  const loadOptions3 = async (inputValue3) => {
    if (inputValue3 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?model=${inputValue3}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const loadOptions2 = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?serialnumber=${inputValue2}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API + `contracts/itemmaster/filter/?itemname=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const handleEdit = (id) => {
    navigate("/itemmasteredit", { state: id });
  };

  const handleView = (id) => {
    navigate("/itemmasterview", { state: id });
  };

  const handleClear = () => {
    setSelectedValue("");
    setSelectedValue2("");
    setSelectedValue3("");
    setSelectedValue4("");
    setSelectedValue5("");
    setSelectedValue6("");
    setAsset_type("")
    ItemMastertableRef.current.onQueryChange();
  };

  const handelDefault = () => {
    let url = API + "contracts/itemmasterview/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data);
      setLoading(false);
    })
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  const handelDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this Item?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            DeleteItemmasterService.deleteitemmaster(id).then((response) => {
              if (response.data.success) {
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                ItemMastertableRef.current.onQueryChange();
              } else {
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            })
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const handleViewRedirect = (id, status, contract_type) => {
    if (status === "Active" || status === "PaidOff") {
      navigate("/contract/view", { state: id });
    } else if (status === "Terminated") {
      navigate("/contract/view", { state: id });
    } else {
      if (contract_type === "Loan") {
        navigate("/editloancontract", { state: id });
      } else if (contract_type === "Rental") {
        navigate("/editrentalcontract", { state: id });
      } else {
        navigate("/contract/edit", { state: id });
      }
    }
  };

  const handleAssetView = (contract_id,conractstatus,contracttype,asset_id) =>{
    if (conractstatus === "Active" || conractstatus === "PaidOff") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id })
    } else if (conractstatus === "Terminated") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id })
    } else {
      if (contracttype === "Loan") {
        navigate(`/editloancontract?Asset=${asset_id}`, { state: contract_id });
      } else if (contracttype === "Rental") {
        navigate(`/editrentalcontract?Asset=${asset_id}`, { state: contract_id });
      } else {
        navigate(`/contract/edit?Asset=${asset_id}`, { state: contract_id });
      }
    }
  }

  return (
    <>
      {loading === false ? (
        <div className="page-wrapper">
          <ToastContainer />
          <div className="content container-fluid">
            <div className="row">
              <div className="">
                <div className="ms-auto my-auto mt-lg-0 mt-4">
                  <div className="ms-auto my-auto"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <div className="body">
                    <div className="p-0">
                      <MaterialTable
                        tableRef={ItemMastertableRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        // onRowClick={(event, rowData) => {
                        //   handleView(rowData.id);
                        // }}
                        title={
                          <h5 className="d-lg-flex">{t("Inventory")}</h5>
                        }
                        columns={[
                          {
                            title: `${t("Item Number")}`,
                            field: "itemname",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Item Number")}{" "}
                                </div>
                                <div className="hyperlink" onClick={()=> handleView(rowData.id)}>
                                  {rowData.itemname}
                                </div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Description")}`,
                            field: "description",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Description")}{" "}
                                </div>
                                <div>
                                  {rowData.description
                                    ? rowData.description
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Serial Number")}`,
                            field: "serialnumber",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Serial Number")}{" "}
                                </div>
                                <div>
                                  {rowData.serialnumber
                                    ? rowData.serialnumber
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Model")}`,
                            field: "model",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Model")}{" "}
                                </div>
                                <div>
                                  {rowData.model ? rowData.model : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Make")}`,
                            field: "make",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">{t("Make")} </div>
                                <div>
                                  {rowData.make ? rowData.make : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Manufacturer")}`,
                            field: "manufacturer",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Manufacturer")}{" "}
                                </div>
                                <div>
                                  {rowData.manufacturer
                                    ? rowData.manufacturer
                                    : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Contract Number")}`,
                            field: "contract_number",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Contract Number")}{" "}
                                </div>
                                <div className="hyperlink"
																			  onClick={() =>
                                          handleViewRedirect(
                                              rowData.contract_id,
                                              rowData.conractstatus,
                                              rowData.contracttype
                                            )
                                        }
                                      >
                                  {rowData.contract_number
                                    ? rowData.contract_number
                                    : ""}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Asset Number")}`,
                            field: "asset_number",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Asset Number")}{" "}
                                </div>
                                <div
                                className="hyperlink"
                                onClick={() => handleAssetView(
                                  rowData.contract_id,
                                  rowData.conractstatus,
                                  rowData.contracttype,
                                  rowData.asset_id
                                )}>
                                  {rowData.asset_number
                                    ? rowData.asset_number
                                    : ""}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Item Type")}`,
                            field: "item_type",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Item Type")}{" "}
                                </div>
                                <div>
                                  {rowData.item_type ? rowData.item_type : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Status")}`,
                            field: "status",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Status")}{" "}
                                </div>
                                <div>
                                  {rowData.status ? rowData.status : "None"}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        // data={items}
                        data={(query) =>
                          new Promise((resolve, reject) => {
                            let url = API + "contracts/itemmasterview/?";
                            url += "per_page=" + query.pageSize;
                            url += "&page=" + (query.page + 1);
                            url += "&search=" + query.search;
                            url += `&itemname=${
                              selectedValue ? selectedValue.itemname : ""
                            }`;
                            url += `&serialnumber=${
                              selectedValue2 ? selectedValue2.serialnumber : ""
                            }`;
                            url += `&model=${
                              selectedValue3 ? selectedValue3.model : ""
                            }`;
                            url += `&make=${
                              selectedValue4 ? selectedValue4.make : ""
                            }`;
                            url += `&status=${
                              selectedValue5 ? selectedValue5.status : ""
                            }`;
                            url += `&manufacturer=${
                              selectedValue6 ? selectedValue6.manufacturer : ""
                            }`;
                            url += `&item_type=${
                              asset_type ? asset_type : ""
                            }`;
                            fetch(url, { headers: authHeader() })
                              .then((response) => response.json())
                              .then((result) => {
                                resolve({
                                  data:
                                    query.orderBy && query.orderDirection
                                      ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                      : result.data,
                                  page: result.page - 1,
                                  totalCount: result.total,
                                });
                              });
                          })
                        }
                        localization={{
                          toolbar: {
                            searchPlaceholder: "Search Item",
                          },
                        }}
                        actions={[
                        
                          (rowData)=>({
                            icon: () => (
                             
                                 permissionss &&  permissionsArray.includes('change_itemmaster')===true ?
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/static/images/ic-edit.svg"
                                }
                                alt="edit"
                              />
                              :""
                            ),
                            tooltip: "Edit",
                            onClick: permissionss &&  permissionsArray.includes('change_itemmaster')===true ? (event, rowData) => {
                              handleEdit(rowData.id);
                            }:"",
                            // hidden: rowData.status === "Inventory" ? false : true
                            
                          })
                          // {
                          //   icon: () => (
                          //     permissionss &&  permissionsArray.includes('delete_itemmaster')===true ?
                          //     <img
                          //       src={
                          //         process.env.PUBLIC_URL +
                          //         "/static/images/ic-delete.svg"
                          //       }
                          //       alt="delete"
                          //     />:""
                          //   ),
                          //   tooltip: "Delete",
                          //   onClick: permissionss &&  permissionsArray.includes('delete_itemmaster')===true ? (event, rowData) => {
                          //     handelDelete(rowData.id);
                          //   }:"",
                          // },
                        ]}
                        components={{
                          Toolbar: (props) => (
                            <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                              <MTableToolbar {...props} />
                              <span
                                onClick={() => setState({ isPaneOpen: true })}
                                style={{
                                  color: "#b4b7c5",
                                  paddingRight: "1px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/static/images/ic-filter.svg"
                                  }
                                  alt="filter"
                                />
                              </span>
                              {
							                  permissionss &&  permissionsArray.includes('add_itemmaster')===true ? 
                                customerPermission !== 'Customer' &&
                              <Link
                                className="navbar-brand m-0"
                                to="/itemmasteradd"
                              >
                                <button
                                  className="add-party add btn btn-primary  mb-0"
                                  id="add-task"
                                >
                                  +&nbsp; {t("Add Item")}
                                </button>
                              </Link>
                              :""
                        }
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: true,
                          toolbar: true,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [10, 20, 25, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportAllData: true,
                          exportButton: true,
                          exportFileName: "Inventory",
                          exportPdf: (data, columns) => {
                            const doc = new jsPDF();
                            const columnTitles = data.map(
                              (columnDef) => columnDef.title
                            );

                            const pdfData = columns.map((rowData) =>
                              data.map(
                                (columnDef) => rowData[columnDef.field]
                              )
                            );
                            // doc.autoTable({
                            autoTable(doc,{
                              head: [columnTitles],
                              body: pdfData,
                            });

                            doc.save(`Inventory.pdf`);
                          },
                          actionsColumnIndex: -1,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <SlidingPane
                  className="some-custom-class"
                  overlayClassName="some-custom-overlay-class"
                  isOpen={state1.isPaneOpen}
                  title="Filter By"
                  onRequestClose={() => {
                    setState({ isPaneOpen: false });
                  }}
                >
                  <div className="col-md-12">
                    <div className="">
                      <div className="">
                        <label className="col-lg-12 col-form-label">
                          {t("Item Number")}
                        </label>
                        <div className="col-lg-12 mb-3">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Item Number (%for All)")}
                            value={selectedValue}
                            getOptionLabel={(e) => e.itemname}
                            getOptionValue={(e) => e.itemname}
                            loadOptions={loadOptions}
                            onInputChange={handelInputChange}
                            onChange={handelChange}
                          ></AsyncSelect>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Serial Number")}
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t(
                              "Search for Serial number(%for All)"
                            )}
                            value={selectedValue2}
                            getOptionLabel={(e) => e.serialnumber}
                            getOptionValue={(e) => e.serialnumber}
                            loadOptions={loadOptions2}
                            onInputChange={handelInputChange2}
                            onChange={handelChange2}
                          ></AsyncSelect>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Model")}
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Model(%for All)")}
                            value={selectedValue3}
                            getOptionLabel={(e) => e.model}
                            getOptionValue={(e) => e.model}
                            loadOptions={loadOptions3}
                            onInputChange={handelInputChange3}
                            onChange={handelChange3}
                          ></AsyncSelect>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Make")}
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Make(%for All)")}
                            value={selectedValue4}
                            getOptionLabel={(e) => e.make}
                            getOptionValue={(e) => e.make}
                            loadOptions={loadOptions4}
                            onInputChange={handelInputChange4}
                            onChange={handelChange4}
                          ></AsyncSelect>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Status")}
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Status(%for All)")}
                            value={selectedValue5}
                            getOptionLabel={(e) => e.status}
                            getOptionValue={(e) => e.status}
                            loadOptions={loadOptions5}
                            onInputChange={handelInputChange5}
                            onChange={handelChange5}
                          ></AsyncSelect>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Manufacture")}
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            defaultOptions
                            isClearable
                            placeholder={t("Search for Manufacture(%for All)")}
                            value={selectedValue6}
                            getOptionLabel={(e) => e.manufacturer}
                            getOptionValue={(e) => e.manufacturer}
                            loadOptions={loadOptions6}
                            onInputChange={handelInputChange6}
                            onChange={handelChange6}
                          ></AsyncSelect>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Item Type")}
                        </label>
                        <div className="col-lg-12">
                        <select
                            className="form-control"
                            name="item_type"
                            value={asset_type}
                            onChange={(e) => setAsset_type(e.target.value)}
                          >
                            <option value="">Select Value</option>
                            <option value="Vehicle">Vehicle</option>
                            <option value="Equipment">Equipment</option>
                          </select>
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <button
                        type="button"
                        className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                        onClick={handleClear}
                      >
                        {t("Reset")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={handelSearch}
                        className="partyFilter add btn btn-primary ms-auto mb-0"
                      >
                        {t("Apply")}
                      </button>
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </SlidingPane>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default ItemMaster;
